import { APP_CONFIG, getHeaders } from "../constants/global-variables.js";

// Returns [{ provider: { id, name, icon, logo }, games: [{ id, name, image, images }] }]
export async function getReeltrixGames() {
    const url = `${APP_CONFIG.URL.apiBasePath}reeltrix/gamelist`;

    try {
        const res = await axios.get(url, { headers: getHeaders() });
        return res.data;
    } catch (err) {

    }
}

// Returns the launch url for a game
export async function reeltrixInitGame(gameId, device, language = "en") {
    const url = `${APP_CONFIG.URL.apiBasePath}reeltrix/init`;

    try {
        const res = await axios.get(url, {
            headers: getHeaders(),
            params: { game_id: gameId, device: device, language: language },
        });
        return res.data;
    } catch (err) {

    }
}
